/* eslint-disable react/prop-types */
import IdCell from "../components/IdCell";
import DefaultCell from "../components/DefaultCell";
import { PublicUser } from "@/data-types/api/auth.types";

export function getDataTableUserData(rows: PublicUser[], currentUsername?: string) {
  return {
    columns: [
      {
        Header: "User ID",
        accessor: "user_id",
        Cell: ({ value, row, toggleAllRowsSelected }: any) => (
          <IdCell
            id={value}
            checked={row.isSelected}
            disabled={value === currentUsername}
            onChange={() => {
              if (!row.isSelected) toggleAllRowsSelected(false);
              row.toggleRowSelected(!row.isSelected);
            }}
          />
        ),
      },
      {
        Header: "Email",
        accessor: "user_email",
        Cell: ({ value }: any) => <DefaultCell value={value} />,
      },
      {
        Header: "Role",
        accessor: "user_role",
        Cell: ({ value }: any) => <DefaultCell value={value} />,
      },
      {
        Header: "Status",
        accessor: "user_status",
        Cell: ({ value }: any) => <DefaultCell value={value} />,
      },
    ],

    rows: Array.isArray(rows)
      ? rows.map((row) => ({
          ...row,
          Email: row.user_email,
        }))
      : [],
  };
}

export function getDataTableRequestData(rows: PublicUser[]) {
  return {
    columns: [
      {
        Header: "Email",
        accessor: "user_email",
        Cell: ({ value, row }: any) => (
          <IdCell
            id={value}
            checked={row.isSelected}
            onChange={() => {
              row.toggleRowSelected(!row.isSelected);
            }}
          />
        ),
      },
      {
        Header: "First name",
        accessor: "user_firstname",
        Cell: ({ value }: any) => <DefaultCell value={value || "—"} />,
      },
      {
        Header: "Last name",
        accessor: "user_lastname",
        Cell: ({ value }: any) => <DefaultCell value={value || "—"} />,
      },
      {
        Header: "Status",
        accessor: "user_status",
        Cell: ({ value }: any) => <DefaultCell value={value} />,
      },
    ],
    rows: Array.isArray(rows) ? rows : [],
  };
}
